import { render, staticRenderFns } from "./BookMostPopularProducts.vue?vue&type=template&id=cbb5e1a6&"
import script from "./BookMostPopularProducts.vue?vue&type=script&lang=js&"
export * from "./BookMostPopularProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports